import { type AxiosInstance } from 'axios';

import type {
  GameSessionResult,
  GameSessionReviewStatus,
  GameSessionStatus,
} from '../../../assets/enums/game-session.enum.ts';
import type { IsoDate, Nullable } from '../../types.ts';

export class SessionsServiceApi {
  constructor(private instance: AxiosInstance) {}

  /** Loads one page of sessions whose created_at falls within the range (both ends inclusive). */
  public async getSessions(params: SessionsServiceListArgs) {
    return this.instance
      .get<SessionsServiceListResponse>('/sessions', {
        params: {
          page: params.page,
          limit: params.limit,
          date_from: params.date_from,
          date_to: params.date_to,
        },
      })
      .then((res) => res.data);
  }
}

export type SessionsServiceListArgs = {
  page: number;
  limit: number;
  date_from: IsoDate;
  date_to: IsoDate;
};

export type SessionsServiceListResponse = {
  sessions: SessionsServiceSession[];
  total: number;
  page: number;
  limit: number;
};

export type SessionsServiceChallengeConfig = {
  id: number;
  display_name: string;
};

export type SessionsServiceSession = {
  id: string;
  player_id: string;
  player_name: Nullable<string>;
  challenge_config_id: number;
  challenge_config: Nullable<SessionsServiceChallengeConfig>;
  status: GameSessionStatus;
  result: Nullable<GameSessionResult>;
  review_status: GameSessionReviewStatus;
  ml_result: Nullable<GameSessionResult>;
  wager_amount: string;
  potential_payout: Nullable<string>;
  final_payout: string;
  created_at: IsoDate;
  completed_at: Nullable<IsoDate>;
  reviewed_at: Nullable<IsoDate>;
  course_id: Nullable<string>;
  is_demo: boolean;
};
